import methodPost from './resolvers/post';
import methodPut from './resolvers/put';
import methodDelete from './resolvers/delete';

export default {
  post: methodPost,
  put: methodPut,
  delete: methodDelete,
};
